import { Component, Input } from '@angular/core';
import { RapidReviewDiagnosisResponse } from '@gandalf/model/rapid-review-diagnosis-response';
import { DATE_FORMATS } from '@shared/constants/date-format.constants';
import { GridUtil, GridUtilService, RevColDef } from 'majora';
import { RapidReviewCarePlanItemResponse } from '@gandalf/model/rapid-review-care-plan-item-response';
import { SharedModule } from '@shared/shared.module';

@Component({
	selector: 'pms-rapid-review-diagnosis',
	imports: [SharedModule],
	templateUrl: './rapid-review-diagnosis.component.html',
})
export class RapidReviewDiagnosisComponent {
	@Input({required: true})
	diagnosis: RapidReviewDiagnosisResponse;

	dateFormat = DATE_FORMATS.MM_DD_YYYY;

	gridColumns: RevColDef<RapidReviewCarePlanItemResponse>[] = [
		GridUtil.buildColumn('CPI Type', 'category'),
		this.gridUtilService.buildDateColumn('Start Date', 'startDate'),
		GridUtil.buildFlexColumn('Description', 'description'),
	];

	constructor(
		private gridUtilService: GridUtilService,
	) {
	}
}
